<template>
  <div id="loginBox" class="login-box border-box" @click.stop>
    <span class="close" @click="close">×</span>
    <div class="title-box">登录</div>
    <div class="from-box">
      <div
        class="item-box flex align-items-center"
        :class="true ? 'border' : 'border-active'"
      >
        <img class="img-box" src="../assets/images/img9.png" alt="" />
        <input
          class="flex-1 input-style"
          type="text"
          v-model="loginData.username"
          placeholder="请输入账号"
        />
      </div>
      <div
        class="item-box flex align-items-center"
        :class="true ? 'border' : 'border-active'"
      >
        <img class="img-box" src="../assets/images/img8.png" alt="" />
        <input
          class="flex-1 input-style"
          type="password"
          v-model="loginData.password"
          placeholder="请输入密码"
        />
      </div>
      <div
        class="item-box flex align-items-center"
        :class="true ? 'border' : 'border-active'"
      >
        <img class="img-box" src="../assets/images/img8.png" alt="" />
        <input
          class="flex-1 input-style"
          type="text"
          v-model="loginData.captcha"
          placeholder="请输入验证码"
          @keyup.enter="keyDown($event)"
        />
        <img
          class="img-box-1"
          :src="verificationImg"
          alt=""
          @click="getCaptcha()"
        />
      </div>
      <div class="item-box bg-980305" @click="goLogin">登录</div>
    </div>
  </div>
</template>

<script>
import { goLogin, getCaptcha } from "../api/index.js";

// 首次登录改密提示标记：登录成功时清除，personalCenter 弹出后置位（避免刷新重复弹）
const FIRST_LOGIN_PWD_PROMPTED_KEY = "firstLoginPwdPrompted";

export default {
  name: "",
  components: {},
  props: {
    loginPath: String,
  },
  data() {
    return {
      verificationImg: "",
      loginData: {
        username: "",
        password: "",
        captcha: "",
        checkKey: "",
      },
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    goLogin() {
      if (this.loginData.username === "") {
        this.$message.info("请输入账号");
        return false;
      } else if (this.loginData.password === "") {
        this.$message.info("请输入密码");
        return false;
      } else if (this.loginData.captcha === "") {
        this.$message.info("请输入验证码");
        return false;
      }
      if (
        this.loginData.username !== "" &&
        this.loginData.password !== "" &&
        this.loginData.captcha !== ""
      ) {
        goLogin(this.loginData).then((res) => {
          if (res.code === 200) {
            this.$store.state.token = res.result.token;
            window.sessionStorage.setItem("token", res.result.token);
            window.sessionStorage.setItem(
              "userInfo",
              JSON.stringify(res.result.userInfo)
            );
            window.sessionStorage.setItem("userRole", res.result.userRole[0]);
            // 每次登录都清掉「已提示过首次改密」标记，保证重新登录后仍会按需弹出
            window.sessionStorage.removeItem(FIRST_LOGIN_PWD_PROMPTED_KEY);
            this.$store.commit("updateUser", res.result.userInfo);
            this.$store.commit("updateToken", res.result.token);
            this.$store.commit("updateRole", res.result.userRole[0]);
            this.$emit("loginSuccess");
            this.$message.success(res.message);
            // draw-role（学校管理角色）登录后默认进入抽奖页
            if (res.result.userRole[0] === "draw-role") {
              this.$router.push({ name: "lottery" });
            } else {
              this.$router.push({ name: "alApply" });
            }
            // this.$router.push({ name: this.loginPath });
//          window.removeEventListener('keyDown',this.keyDown,false)
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.info("请填写完整登录表单");
      }
    },
    keyDown(e) {
    	console.log(e);
      if (e.keyCode == 13) {
        this.goLogin();
        return false;
      }
    },
    getCaptcha() {
      this.loginData.checkKey = new Date().getTime();
      getCaptcha(this.loginData.checkKey).then((res) => {
        this.verificationImg = res.result;
      });
    },
    close(){
      this.$emit("close")
    }
  },
  destroyed(){
//  window.removeEventListener('keyDown',this.keyDown,false)
  }
};

</script>

<style scoped lang="scss">
.img-box {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-1 {
  width: 100px;
  height: auto;
}
.login-box {
  width: 512px;
  height: 412px;
  padding: 20px 86px;
  margin-bottom: 14%;
  background: #fff;
  border-radius: 30px;
  // background: url("../assets/images/img19.png") no-repeat;
  // background-size: 100% 100%;
  position: relative;
  border:2px solid #9A0B00;
  box-sizing: border-box;
  &::before{
    content:'';
    width: 100%;
    border-radius: 30px;
    background: #9A0B00;
    position: absolute;
    top: 110px;
    bottom: -12px;
    right:-12px;
    z-index: -1;
  }
}
.title-box {
  // height: 60px;
  // margin-top: 20px;
  // line-height: 60px;
  text-align: center;
  font-weight: 800;
  font-size: 22px;
  color: #9A0B00;
  font-family:'宋体';
  // border-bottom: 1px solid #ccc;
}
.input-style {
  border: none;
  color: #7d7d7d;
  height: 100%;
}
.item-box {
  padding: 0 20px;
  height: 47px;
  line-height: 47px;
  border-radius: 24px;
}
.border {
  border: 1px solid #dcdcdc;
  background: #fff;
}
.border-active {
  border: 1px solid #eecfc9;
}
.item-box:nth-child(1) {
  margin-top: 27px;
}
.item-box:nth-child(2) {
  margin-top: 23px;
}
.item-box:nth-child(3) {
  margin-top: 23px;
}
.item-box:nth-child(4) {
  margin-top: 30px;
  text-align: center;
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.bg-980305 {
  background: #9A0B00;
}
.close {
  color: #A1A1A1;
  font-size: 36px;
  position: absolute;
  right: 10%;
  cursor: pointer;
  top:10px;
}
</style>
